	  //外部サーバーからデータ取得して納期情報を表示
    function fnc_get_stockinfo(type,val){
    $.ajax({
          url : "https://www.ntec.co.jp/stocklink/v-step1/api/sf_productdetail_stockinfo.php?type="+type+"&val="+val,
          type : "GET",               //GETメソッドでサーバーから取得し
          dataType : "text",          //処理結果はjson形式で受信
          cache:false,
          xhrFields: {
            withCredentials: true
          },
          success : function(data){   //取得が成功したらtestdata.jsonをコールバック関数のfunctionの引数dataにセット
            if(data){
              document.getElementById("custom_stock_status").innerHTML=data;
            } else{
              document.getElementById("custom_stock_status").innerHTML='';
            }
          },
          error:function(XMLHttpRequest, textStatus, errorThrown){
//            alert('error!!!');
//        　　console.log("XMLHttpRequest : " + XMLHttpRequest.status);
//            console.log("textStatus     : " + textStatus);
//        　　console.log("errorThrown    : " + errorThrown.message);
            document.getElementById("custom_stock_status").innerHTML='';
          }
      });
  }
